/**
 * Done. CPD — Onboarding Page (/onboarding)
 *
 * Hosts the Stitch v2 personalisation survey. OnboardingSurvey owns all
 * section/progress state internally.
 */

import { OnboardingLayout } from '@/layouts/OnboardingLayout';
import { OnboardingSurvey } from '@/components/features/OnboardingSurvey';

export function OnboardingPage(): React.ReactElement {
  return (
    <OnboardingLayout>
      <OnboardingSurvey />
    </OnboardingLayout>
  );
}
